@if (shouldShowManageExcludedClients) {
  <h3 class="body-400">Excluded {{ statementRecipientLabel$ | async }}s: {{ excludedStatementRecipientsAmount$ | async }}</h3>

  <p class="small-300">Exclude {{ statementRecipientLabel$ | async }}s from receiving any statements via Aiwyn.</p>

  <button id="open-manage-excluded-button" class="button" [disabled]="disabled" (click)="openManageExcludedClientsDialog()">
    Manage Excluded {{ statementRecipientLabel$ | async | titlecase }}s
  </button>
} @else {
  <h3 class="body-400">Excluded {{ statementRecipientLabel$ | async }}</h3>

  <p class="small-300">
    Exclude {{ statementRecipientLabel$ | async }}s are managed in your practice management system, as set during implementation.
  </p>

  <p id="manage-excluded-disabled-note" class="small-300">
    To manage exclusions directly in Aiwyn instead, please
    <a href="https://www.firmsupport.aiwyn.ai/hc/en-us/requests/new" target="_blank">contact Support.</a>
  </p>
}
